<template>
    <div>
        <div ref="container" :class="{'tw-line-clamp-10':!expanded}">
            <slot></slot>
        </div>

        <div v-if="expandable">
            <p class="tw-tracking-wide tw-inline-block tw-cursor-pointer tw-text-pia-red tw-font-bold" @click="expanded = !expanded">
                {{ expanded ? 'SHOW LESS' : 'READ MORE' }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "ShowMore",

    data() {
        return {
            expanded: false,
            expandable: false
        }
    },

    mounted() {
        window.addEventListener('load', () => {
            this.checkExpandable();
        });
    },

    methods: {
        checkExpandable() {
            if(this.$refs.container.clientHeight < this.$refs.container.scrollHeight) {
                this.expandable = true;
            }
        }
    }
}
</script>

<style>

</style>